export interface Product {
  id: string;
  name: string;
  sku?: string;
  category: string;
  collection: string;
  collectionSlug: string;
  colors: string[];
  priceRange: string;
  brand: string;
  image: string;
  description: string;
  features: string[];
  badges?: string[];
}

export const products: Product[] = [
  // Hardwood Products - Solo Collection
  {
    id: "hw-1",
    name: "Natural Oak Plank",
    sku: "MNF101-00101",
    category: "hardwood",
    collection: "Solo Collection",
    collectionSlug: "solo-collection",
    colors: ["Natural", "Light Brown"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&auto=format&fit=crop",
    description: "Premium solid oak hardwood with natural grain patterns",
    features: ["Solid Wood", "25-Year Warranty", "Easy Installation"],
    badges: ["Real Wood"],
  },
  {
    id: "hw-2",
    name: "Walnut Estate",
    sku: "MNF101-00102",
    category: "hardwood",
    collection: "Solo Collection",
    collectionSlug: "solo-collection",
    colors: ["Dark Brown", "Espresso"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=800&auto=format&fit=crop",
    description: "Rich walnut hardwood for elegant spaces",
    features: ["Engineered Wood", "Scratch Resistant", "Pet Friendly"],
    badges: ["Real Wood"],
  },
  {
    id: "hw-3",
    name: "Maple Classic",
    sku: "MNF101-00103",
    category: "hardwood",
    collection: "Solo Collection",
    collectionSlug: "solo-collection",
    colors: ["Blonde", "Light"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?w=800&auto=format&fit=crop",
    description: "Timeless maple hardwood with smooth finish",
    features: ["Solid Wood", "High Durability", "Traditional Look"],
    badges: ["Real Wood"],
  },
  {
    id: "hw-4",
    name: "Hickory Ranch",
    sku: "MNF101-00104",
    category: "hardwood",
    collection: "Solo Collection",
    collectionSlug: "solo-collection",
    colors: ["Multi-Tone", "Rustic"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800&auto=format&fit=crop",
    description: "Rustic hickory with character and durability",
    features: ["Hardest Domestic Wood", "Character Grade", "Lifetime Warranty"],
    badges: ["Real Wood"],
  },
  // Hardwood Products - Canto Collection (Custom)
  {
    id: "hw-5",
    name: "Artisan White Oak",
    sku: "MNF102-00101",
    category: "hardwood",
    collection: "Canto Collection",
    collectionSlug: "canto-collection",
    colors: ["Natural", "Custom"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&auto=format&fit=crop",
    description: "Custom hand-scraped white oak with bespoke finishes",
    features: ["Custom Stains", "Hand-Scraped", "Wide Plank"],
    badges: ["Custom", "Real Wood"],
  },
  {
    id: "hw-6",
    name: "Heritage Walnut",
    sku: "MNF102-00102",
    category: "hardwood",
    collection: "Canto Collection",
    collectionSlug: "canto-collection",
    colors: ["Dark Brown", "Custom"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&auto=format&fit=crop",
    description: "Exclusive walnut with custom width options",
    features: ["Custom Widths", "Exclusive Patterns", "Lifetime Warranty"],
    badges: ["Custom", "Real Wood"],
  },
  // Vinyl Products - Evo Collection
  {
    id: "vn-1",
    name: "Luxury Vinyl Plank",
    sku: "MNF201-00101",
    category: "vinyl",
    collection: "Evo Collection",
    collectionSlug: "evo-collection",
    colors: ["Gray", "Greige"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&auto=format&fit=crop",
    description: "Waterproof luxury vinyl with realistic wood look",
    features: ["100% Waterproof", "Click-Lock Install", "Quiet Underfoot"],
    badges: ["Waterproof"],
  },
  {
    id: "vn-2",
    name: "Stone Look Vinyl",
    sku: "MNF201-00102",
    category: "vinyl",
    collection: "Evo Collection",
    collectionSlug: "evo-collection",
    colors: ["White", "Marble"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1508873696983-2dfd5898f08b?w=800&auto=format&fit=crop",
    description: "Elegant stone appearance with vinyl durability",
    features: ["Waterproof", "Low Maintenance", "Warm Underfoot"],
    badges: ["Waterproof"],
  },
  {
    id: "vn-3",
    name: "Modern Gray Plank",
    sku: "MNF201-00103",
    category: "vinyl",
    collection: "Evo Collection",
    collectionSlug: "evo-collection",
    colors: ["Gray", "Charcoal"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1622127922040-13cab637ee78?w=800&auto=format&fit=crop",
    description: "Contemporary gray vinyl for modern homes",
    features: ["Scratch Resistant", "Kid Proof", "Affordable"],
    badges: ["Waterproof"],
  },
  // Carpet Products - Echo Collection (Pattern)
  {
    id: "cp-1",
    name: "Composition - Echo+",
    sku: "MNF515-00101",
    category: "carpet",
    collection: "Echo Collection",
    collectionSlug: "echo-collection",
    colors: ["Multi", "Pattern"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&auto=format&fit=crop",
    description: "Premium pattern carpet from the Echo Collection",
    features: ["Commercial Grade", "Pattern Hides Dirt", "Long Lasting"],
    badges: ["Waterproof", "CRI Green Label Plus"],
  },
  {
    id: "cp-2",
    name: "Frieze Textured",
    sku: "MNF301-00103",
    category: "carpet",
    collection: "Echo Collection",
    collectionSlug: "echo-collection",
    colors: ["Gray", "Neutral"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&auto=format&fit=crop",
    description: "Textured frieze with modern casual look",
    features: ["Hides Footprints", "Durable Twist", "Easy Clean"],
    badges: ["CRI Green Label Plus"],
  },
  // Carpet Products - Verso Collection (Texture)
  {
    id: "cp-3",
    name: "Plush Comfort",
    sku: "MNF301-00101",
    category: "carpet",
    collection: "Verso Collection",
    collectionSlug: "verso-collection",
    colors: ["Beige", "Cream"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=800&auto=format&fit=crop",
    description: "Soft plush carpet perfect for bedrooms",
    features: ["Stain Resistant", "Soft Touch", "Hypoallergenic"],
    badges: ["CRI Green Label Plus"],
  },
  {
    id: "cp-4",
    name: "Velvet Touch",
    sku: "MNF301-00104",
    category: "carpet",
    collection: "Verso Collection",
    collectionSlug: "verso-collection",
    colors: ["Cream", "Ivory"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&auto=format&fit=crop",
    description: "Luxurious velvet texture for elegant spaces",
    features: ["Ultra Soft", "Stain Resistant", "Premium Quality"],
    badges: ["CRI Green Label Plus"],
  },
  // Tile Products - Flow Collection (Porcelain)
  {
    id: "tl-1",
    name: "Porcelain Wood Look",
    sku: "MNF401-00101",
    category: "tile",
    collection: "Flow Collection",
    collectionSlug: "flow-collection",
    colors: ["Natural", "Oak"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&auto=format&fit=crop",
    description: "Porcelain tile with authentic wood appearance",
    features: ["Waterproof", "Scratch Proof", "Heat Resistant"],
    badges: ["Waterproof"],
  },
  {
    id: "tl-2",
    name: "Subway Classic",
    sku: "MNF401-00102",
    category: "tile",
    collection: "Flow Collection",
    collectionSlug: "flow-collection",
    colors: ["White", "Glossy"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800&auto=format&fit=crop",
    description: "Timeless subway tile for backsplashes and walls",
    features: ["Classic Design", "Budget Friendly", "Versatile"],
  },
  // Tile Products - Hydro Collection (Engineered)
  {
    id: "tl-3",
    name: "Marble Elegance",
    sku: "MNF402-00101",
    category: "tile",
    collection: "Hydro Collection",
    collectionSlug: "hydro-collection",
    colors: ["White", "Carrara"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&auto=format&fit=crop",
    description: "Luxurious marble-look porcelain for elegant spaces",
    features: ["Polished Finish", "Luxury Look", "Easy Maintenance"],
    badges: ["Waterproof"],
  },
  {
    id: "tl-4",
    name: "Slate Stone",
    sku: "MNF402-00102",
    category: "tile",
    collection: "Hydro Collection",
    collectionSlug: "hydro-collection",
    colors: ["Gray", "Charcoal"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&auto=format&fit=crop",
    description: "Natural slate look with advanced waterproofing",
    features: ["100% Waterproof", "Outdoor Safe", "Durable"],
    badges: ["Waterproof"],
  },
  // Laminate Products - Novo Collection
  {
    id: "lm-1",
    name: "Oak Impression",
    sku: "MNF501-00101",
    category: "laminate",
    collection: "Novo Collection",
    collectionSlug: "novo-collection",
    colors: ["Natural", "Honey"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=800&auto=format&fit=crop",
    description: "Realistic oak laminate at an affordable price",
    features: ["Easy DIY Install", "Scratch Resistant", "Budget Friendly"],
    badges: ["Water Resistant"],
  },
  {
    id: "lm-2",
    name: "Barnwood Rustic",
    sku: "MNF501-00102",
    category: "laminate",
    collection: "Novo Collection",
    collectionSlug: "novo-collection",
    colors: ["Gray", "Weathered"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&auto=format&fit=crop",
    description: "Rustic barnwood look with modern performance",
    features: ["Water Resistant", "Hand-Scraped Texture", "Trendy Style"],
    badges: ["Water Resistant"],
  },
  {
    id: "lm-3",
    name: "Hickory Bronze",
    sku: "MNF501-00103",
    category: "laminate",
    collection: "Novo Collection",
    collectionSlug: "novo-collection",
    colors: ["Brown", "Bronze"],
    priceRange: "Get Quote",
    brand: "MyNewFloor",
    image: "https://images.unsplash.com/photo-1557734864-c78b6dfef1b1?w=800&auto=format&fit=crop",
    description: "Rich hickory laminate with bronze undertones",
    features: ["12mm Thick", "AC4 Rating", "Lifetime Warranty"],
    badges: ["Water Resistant"],
  },
];

export const categories = [
  { id: "hardwood", name: "Hardwood", count: 4 },
  { id: "vinyl", name: "Vinyl", count: 3 },
  { id: "carpet", name: "Carpet", count: 3 },
  { id: "tile", name: "Tile", count: 3 },
  { id: "laminate", name: "Laminate", count: 3 },
];

export const collections = [
  { id: "solo", name: "Solo Collection", description: "Real Wood" },
  { id: "evo", name: "Evo Collection", description: "Vinyl" },
  { id: "echo", name: "Echo Collection", description: "Pattern Carpet" },
  { id: "novo", name: "Novo Collection", description: "Laminated Wood" },
  { id: "verso", name: "Verso Collection", description: "Texture Carpet" },
  { id: "hydro", name: "Hydro Collection", description: "Engineered Tile" },
  { id: "flow", name: "Flow Collection", description: "Porcelain Tile" },
];

export const colors = [
  "Natural",
  "Light Brown",
  "Dark Brown",
  "Gray",
  "White",
  "Beige",
  "Multi",
  "Blonde",
  "Espresso",
];

export const brands = ["MyNewFloor"];

export const getProductsByCategory = (category: string) => {
  return products.filter((p) => p.category === category);
};

export const getCategoryInfo = (category: string) => {
  return categories.find((c) => c.id === category);
};

// Simple slug mapping - same IDs for new URL structure
export const categorySlugMap: Record<string, string> = {
  "hardwood": "hardwood",
  "vinyl": "vinyl",
  "carpet": "carpet",
  "tile": "tile",
  "laminate": "laminate",
};

// Helper to resolve slug to internal category ID
export const resolveCategorySlug = (slugOrCategory: string): string => {
  return categorySlugMap[slugOrCategory] || slugOrCategory;
};
